import React from "react";
import FormsButton from "../../components/FormSection/FormsButton";
import classes from "../../components/FormSection/FormsButton.module.css";

function Form() {
  const options = [
    {
      name: "Loan Servicing Order Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Servicing-Order-Form_2023.pdf",
    },
    {
      name: "Demand Request Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/08/Draw-Request-Form_2023.pdf",
    },
    // {
    //   name: "Statement of Information",
    //   href: "https://superiorloanservicing.com/wp-content/uploads/2022/03/Statement-of-Information-Form.pdf",
    // },
    {
      name: "Loan Doc Order Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Loan-Document-Order-Form_2023.pdf",
    },
    {
      name: "Add'l Lender Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Lender-Form-Additional-Lender-Form_2023.pdf",
      href: "",
    },
    {
      name: "Verification of Mortgage",
      href: "https://superiorloanservicing.com/wp-content/uploads/2022/03/Verification-of-Mortgage.pdf",
    },
    {
      name: "Change of Address Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Change-of-Address-Form_2023.pdf",
    },
    {
      name: "Signature Authorization",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Lender-3rd-Party-Authorization_2023.pdf",
    },
    {
      name: "1003 Loan Application",
      href: "https://superiorloanservicing.com/wp-content/uploads/2022/03/1003-Loan-Application-1.pdf",
    },
  ];

  const options1 = [
    {
      name: "Loan Servicing Order Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Servicing-Order-Form_2023.pdf",
    },
    {
      name: "Demand Request Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/SLS-Demand-Request-Form-2023_0624-1.pdf",
    },
    {
      name: "IRS - W9 Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2022/03/IRS_W9_blank.pdf",
    },
    {
      name: "Add'l Lender Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Lender-Form-Additional-Lender-Form_2023.pdf",
    },
    {
      name: "Verification of Mortgage",
      href: "https://superiorloanservicing.com/wp-content/uploads/2022/03/Verification-of-Mortgage.pdf",
    },
    {
      name: "ACH Enrollment Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/ACH-Direct-Deposit-Form-Lender_2023.pdf",
    },
    {
      name: "Lender 3rd Party Auth.",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Lender-3rd-Party-Authorization_2023.pdf",
    },
    {
      name: "Change of Address Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Change-of-Address-Form_2023.pdf",
    },
    {
      name: "Loan Doc Order Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Loan-Document-Order-Form_2023.pdf",
    },
    {
      name: "Draw Request Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2024/03/Draw-Request-Form_2023-4.pdf",
    },
  ];

  const options2 = [
    {
      name: "Change of Address Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Change-of-Address-Form_2023.pdf",
    },
    {
      name: "One-Time ACH Payment",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/ACH-Direct-Debit-Form-ONE-TIME_2023.pdf",
    },
    {
      name: "Recurring ACH Payment",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/ACH-Direct-Debit-Form-Recurring_2023.pdf",
    },
    {
      name: "Demand Request Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/SLS-Demand-Request-Form-2023_0624-1.pdf",
    },
    {
      name: "IRS - W9 Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2022/03/IRS_W9_blank.pdf",
    },
    {
      name: "Signature Authorization",
      href: "https://superiorloanservicing.com/wp-content/uploads/2022/03/borrower_signature_authorization.pdf",
    },
    // {
    //   name: "Statement of Information",
    //   href: "https://superiorloanservicing.com/wp-content/uploads/2022/03/Statement-of-Information-Form.pdf",
    // },
    {
      name: "Draw Request Form",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Draw-Request-Form_2023.pdf",
    },
    {
      name: "Borrower 3rd Party Auth.",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/10/Borrower-3rd-Party-Authorization_2023.pdf",
    },
    {
      name: "Financial Assistance",
      href: "https://superiorloanservicing.com/wp-content/uploads/2023/04/Financial-Assistance-Request-Form_2023.pdf",
    },
  ];

  return (
    // <div >
    <section
      className="text-start container-fluid my-4 px-0 rounded"
      style={{ background: "#eeeeee", minHeight: "100vh" }}
    >
      <div className="container-fluid">
        <div className="p-3 pb-0  mt-1">
          <div style={{ backgroundColor: "#FF8057", padding: "36px 0" }}>
            <h3
              style={{
                fontSize: "55px",
                color: "#fff",
                textAlign: "center",
                padding: "17px 0",
              }}
            >
              Forms
            </h3>
          </div>
          <FormsButton
            heading="Loan Servicing Forms for Brokers"
            options={options}
            classname={classes.background}
          />
          <FormsButton
            heading="Loan Servicing Forms for Lenders"
            options={options1}
            classname={`mt-3`}
          />
          <FormsButton
            heading="Loan Servicing Forms for Borrowers"
            options={options2}
            classname={`mt-3 ${classes.background}`}
          />
        </div>
      </div>
    </section>
    // </div>
  );
}

export default Form;
